import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '../components/MainPage/MainPage'
import Terminal from '../components/MainPage/Terminal/Terminal2'
import TerminalAdvanced from '../components/MainPage/Terminal/TerminalAdvanced'
import Screener from '../components/Screener/Screener'
import Login from '../components/Auth/Login'
import Forgot from '../components/Auth/Forgot'
import Signup from '../components/Auth/Signup'
import Settings from '../components/Settings'
import RefCab from '../components/MainPage/RefCab/RefCab'
import Portfolio from '../components/MainPage/Portfolio/Portfolio'
import Pay from '../components/MainPage/Pay/Pay'
import Bots from '../components/MainPage/Bots/Bots'
import Grids from '../components/MainPage/Grids/Grids'
import FastBot from '../components/MainPage/Fastbot/Fastbot'
import Stats from '../components/MainPage/Stats/Stats'
import Hooks from '../components/MainPage/Hooks/Hooks'
// import Countly from 'countly-sdk-web'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem('token') != null && localStorage.getItem('token') !== '') {
    next()
    return
  }
  next('/login')
}

const track = (to, from, next) => {
  // if (process.env.VUE_APP_BASE_URL.includes('moon')) {
  //   Countly.q.push(['track_pageview', to.name])
  // }
  next()
}

export default new Router({
  mode: 'history',
  base: '/app',
  routes: [
    {
      path: '/',
      // name: 'MainPage',
      component: MainPage,
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/',
          name: 'portfolio',
          component: Portfolio,
          beforeEnter: track,
          meta: {
            showHeader: true
          }
        },
        {
          path: '/terminal',
          name: 'terminal',
          components: {
            'terminal-default': Terminal,
            'terminal-advanced': TerminalAdvanced
          },
          beforeEnter: track,
          meta: {
            showHeader: true,
            showDemoBackground: true,
            watchLastPrice: true
          }
        },
        {
          path: '/settings',
          name: 'settings',
          component: Settings,
          beforeEnter: track
        },
        {
          path: '/refcab',
          name: 'refcab',
          component: RefCab,
          beforeEnter: track
        },
        {
          path: '/pay',
          name: 'pay',
          component: Pay,
          beforeEnter: track
        },
        {
          path: '/bots',
          name: 'bots',
          component: Bots,
          beforeEnter: track,
          meta: {
            showHeader: true,
            showDemoBackground: true,
            watchLastPrice: true
          }
        },
        {
          path: '/grids',
          name: 'grids',
          component: Grids,
          beforeEnter: track,
          meta: {
            showHeader: true,
            showDemoBackground: true,
            watchLastPrice: true
          }
        },
        {
          path: '/booster',
          name: 'booster',
          component: FastBot,
          beforeEnter: track
        },
        {
          path: '/stats',
          name: 'stats',
          component: Stats,
          beforeEnter: track,
          meta: {
            showHeader: true
          }
        },
        {
          path: '/hooks',
          name: 'hooks',
          component: Hooks,
          beforeEnter: track
        }
      ]
    },
    {
      path: '/multichart',
      name: 'screener',
      beforeEnter: ifAuthenticated,
      component: Screener
    },
    {
      path: '/login/:ctok?',
      name: 'login',
      component: Login
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/forgot/:ctok?',
      name: 'forgot',
      component: Forgot
    }
  ]
})
